import React, { useEffect, useState } from 'react';
import { KChatPanel } from 'kn-chat-app';
import { useSelector } from 'react-redux';
import { CHAT_COMPONENTS, CONTEXT_TYPES, VIEW_MODES } from '../constants';
import { cookieNames, getCookie } from '../../util';
import { HttpClient as API } from '../../Api/httpClient';
import { get } from 'lodash';

const Conversations = (props) => {
  const {
    contextId = '',
    contextType = CONTEXT_TYPES.CONTAINER,
    viewMode = VIEW_MODES.MODAL,
    conversationId = '',
    kxUser = {},
    style = {},
    subContextType = CONTEXT_TYPES.SHIPMENT,
    subContextIds = [],
    onCloseModal = () => {}
  } = props;
  const [userData, setUserData] = useState({});

  const userToken = getCookie(cookieNames.KxCommon);

  
  useEffect(() => {
    const getUserDetails = () => {
      API.getKxuser(userToken)
        .then((res) => {
          return res.json();
        })
        .then((res) => {
          setUserData(get(res, 'eventMessage.userBasicInfo', null));
        })
        .catch((err) => {
          console.error(err);
        });
    };
    if (userToken) {
      getUserDetails();
    }
  }, [ userToken]);

  const userDetails = React.useMemo(
    () => ({
      userGuid: userData?.userGuid,
      userName: userData?.contactName || userData?.fullName,
      userEmail: userData?.email,
    }),
    [userData]
  );

  return (
    <div style={{ ...style }}>
      {userData?.userGuid && (
        <KChatPanel
          userDetails={userDetails}
          component={CHAT_COMPONENTS.CHAT_WORKSPACE}
          contextDetails={{
            contextId: contextId,
            contextType: contextType,
            subContextType: subContextType,
            subContextIds: subContextIds,
          }}
          onCloseModal={onCloseModal}
          conversationId={conversationId} // to select the specific conversation on page load
          viewMode={viewMode ? viewMode : VIEW_MODES.LIST}
          style={
            viewMode === VIEW_MODES.WORKSPACE
              ? { height: 'calc(100vh - 50px)', width: '100vw' }
              : {}
          }
        ></KChatPanel>
      )}
    </div>
  );
};

export default React.memo(Conversations,
  // Only re-render if contextId or contextType changes
  (prevProps, nextProps) => {
    return (
      prevProps.contextId === nextProps.contextId &&
      prevProps.contextType === nextProps.contextType
    );
  }
);
